<template>
    <div class="progress">
        <span 
            v-for="(i, index) in 3" 
            :key="index"
            class="progress__item" 
            :class="{'progress__item--active': index + 1 === step}"
        ></span>
    </div>
</template>

<script>
export default {
    name: "ProfileNewProgress",
    props: {
        step: {
            type: Number,
            required: true,
            default: 1
        }
    }
};
</script>